import React, { useState, useEffect, useMemo } from 'react'
import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import TableContainer from "../tables_manager/TableContainer"
import Loading from '../Loading';
import EncaissementScanModal from '../encaissement_list/EncaissementScanModal';
import { getEncaissementsExcel, clearEncaissements } from '../../flux/actions/encaissementActions';
import { getVenteByIdPromise } from '../../flux/actions/venteActions';
import { connect } from 'react-redux';
import * as XLSX from 'xlsx'
import moment from "moment";
import { DateRangeColumnFilter, NumberRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import { IRapprochementEnc, IRapprochementEncReduxProps } from '../../types/interfaces';
import { useDropzone } from 'react-dropzone';
import { useAlert } from "react-alert";
import { E_ERROR } from '../../types/errors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExchangeAlt, faExternalLinkAlt, faFileExcel, faFileImage, faFileInvoice, faHandRock, faMoneyBillWave, faMoneyCheck, faMoneyCheckAlt, faPen, faSpinner, faSyncAlt, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import PDFLink from '../pdf/PDFLink';
import { getEncModeRegl, getEncStatut } from '../../services/misc';
import { constants } from '../../types/constants';
import RapprochementFooter from './RapprochementFooter';
import RapprochementTable from './RapprochementTable';

const RapprochementEncContainer = ({ 
  getEncaissementsExcel,
  clearEncaissements,
  encaissement,
  auth
 }: IRapprochementEnc) => {
  const alert = useAlert();
  const bank_AWB = "AWB"
  const bank_BMCE = "BMCE"
  const { encaissements, loading } = encaissement;
  const [activeTab, setActiveTab] = useState("RELEVE");
  const [data, setData] = useState<any>(undefined)
  const [virements, setVirements] = useState<any[]>([])
  const [versements, setVersements] = useState<any[]>([])
  const [checks, setChecks] = useState<any[]>([])
  const [impayes, setImpayes] = useState<any[]>([])
  const [clearFiltersVirements, setClearFiltersVirements] = useState(false);
  const [clearFiltersVersements, setClearFiltersVersements] = useState(false);
  const [clearFiltersChecks, setClearFiltersChecks] = useState(false);
  const [clearFiltersImpayes, setClearFiltersImpayes] = useState(false);
  const [selectedVirements, setSelectedVirements] = useState(Array());
  const [selectedVersements, setSelectedVersements] = useState(Array());
  const [selectedChecks, setSelectedChecks] = useState(Array());
  const [selectedImpayes, setSelectedImpayes] = useState(Array());
  const [excelFiles, setExcelFiles] = useState<any[]>([]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: ['.xls', '.xlsx'],
    multiple: false,
    maxSize: 30000000,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setExcelFiles(acceptedFiles);
      if(rejectedFiles?.length && rejectedFiles[0].errors){
        if(rejectedFiles[0].errors.find(e => e.code === "file-invalid-type"))
          alert.error("Veuillez sélectionner des fichiers Excel")
        else if(rejectedFiles[0].errors.find(e => e.code === "file-too-large"))
          alert.error("La taille du fichier est supérieure à 30 Mo")
      }
    }
  });
  const [modal, setModal] = useState(false);
  const [modalEncaissement, setModalEncaissement] = useState<any>('');
  const [selectTriggerVirements, setSelectTriggerVirements] = useState(0)
  const [selectTriggerVersements, setSelectTriggerVersements] = useState(0)
  const [selectTriggerChecks, setSelectTriggerChecks] = useState(0)
  const [selectTriggerImpayes, setSelectTriggerImpayes] = useState(0)

  const refreshData = () => {
    if(loading) return
    clearEncaissements()
    if(!data?.rib)
      return
    setSelectTriggerVirements(0)
    setSelectTriggerVersements(0)
    setSelectTriggerChecks(0)
    setSelectTriggerImpayes(0)
    const extractNumber = str => {
      if(/^\d+$/.test(str)) return str
      let match = str.match(/[^0-9](\d+)$/)
      return match ? match[1] : ''
    }
    getEncaissementsExcel(extractNumber(data.rib))
  }
  
  useEffect(() => {
    refreshData()
  }, [getEncaissementsExcel, data?.rib]);
  
  useEffect(() => {
    return () => {
      clearEncaissements();
    }
  }, []);

  const columns = [
    {
      Header: "Ligne N°",
      accessor: e => e.RELEVE_excel_line ? (Number(e.RELEVE_excel_line || 0) + 1) : e.RELEVE_id,
      Filter: NumberRangeColumnFilter,
      filter: 'between',
      Cell: ({ row: {original} }) => original.RELEVE_excel_line ? `${Number(original.RELEVE_excel_line || 0) + 1} (${original.RELEVE_id})` : original.RELEVE_id,
    },
    {
      Header: "Date",
      accessor: "RELEVE_date",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
    },
    {
      Header: "Libellé Opération",
      accessor: "RELEVE_libelle",
      Cell: ({ value }) => value || "-"
    },
    {
      Header: "Valeur",
      accessor: "RELEVE_valeur",
      Filter: DateRangeColumnFilter,
      filter: "dateBetween",
      Cell: ({ value }) => value ? moment(value).format('DD/MM/YYYY') : "-"
    },
    {
      Header: "Débit",
      accessor: "RELEVE_debit",
      Filter: NumberRangeColumnFilter,
      filter: 'between',
      Cell: ({ value }) => !!value || value === 0 ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
    },
    {
      Header: "Crédit",
      accessor: "RELEVE_credit",
      Filter: NumberRangeColumnFilter,
      filter: 'between',
      Cell: ({ value }) => !!value || value === 0 ? (value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh") : "-"
    },
    {
      Header: "Type",
      accessor: e => e.RELEVE_debit ? "Débit" : e.RELEVE_credit ? "Crédit" : "Inconnu",
      Filter: SelectColumnFilter,
      filter: 'equals',
    },
  ];

  useEffect(() => {
    if(!excelFiles.length){
      setData(undefined)
      return
    }
    const parseFile = async () => {
      const file = excelFiles[0]
      const buffer = await file.arrayBuffer()
      const wb = XLSX.read(buffer, { type: 'array' })
      // const wb = XLSX.read(excelFiles[0], { type: 'binary' })
      const firstSheetName = wb.SheetNames[0]
      const ws = wb.Sheets["RELEVE"] || wb.Sheets["imprimerListOperation"] || wb.Sheets[firstSheetName]
      let jsonData: any = XLSX.utils.sheet_to_json(ws)
      const convertExcelDate = serial => {
        const utc_days = Math.floor(serial - 25569)
        const utc_value = utc_days * 86400
        const date_info = new Date(utc_value * 1000)
        return date_info.toISOString().split('T')[0]
      }
      console.log([...jsonData])
      if(jsonData && jsonData.length > 0){
        if(!!Object.keys(jsonData[0]).find(e => e?.toLowerCase().startsWith("status of your account") || e?.toLowerCase().startsWith("situation de votre compte"))){
          let rib
          const firstRow = jsonData?.[0]
          if(firstRow){
            for(let key in firstRow)
              if(firstRow[key]?.toLowerCase().replace(/[.\-\/\\_]+/g, '').includes("rib")){
                rib = firstRow[key]?.toLowerCase().replace(/[.\-\/\\_]+/g, '').replace(/\D/g, '')
                if(rib?.startsWith("780"))
                  rib = rib.substring(3)
                break
              }
          }
          jsonData = jsonData
            .filter((_, key, a) => ![0, 1, 2, 3, a.length - 1, a.length - 2].includes(key))
            .map((e, i) => {
              const result: any = {RELEVE_id: Number(i) + 1, RELEVE_excel_line: e.__rowNum__}
              for(let key in e){
                if(key.toLowerCase().startsWith("status of your account") || key.toLowerCase().startsWith("situation de votre compte")){
                  const match = key.match(/_(\d+)$/)
                  const index = match ? Number(match[1]) : 0
                  result[index] = e[key]
                  switch(index){
                    case 0: result.RELEVE_date = typeof e[key] === 'number' ? convertExcelDate(e[key]) : e[key]; break;
                    case 1: result.RELEVE_valeur = typeof e[key] === 'number' ? convertExcelDate(e[key]) : e[key]; break;
                    case 2: result.RELEVE_libelle = e[key] || ""; break;
                    case 3: result.RELEVE_debit = Math.abs(Number(e[key] || 0)); break;
                    case 4: result.RELEVE_credit = Number(e[key] || 0); break;
                  }
                }
              }
              return result
            })
          setData({lines: jsonData, rib, bankName: bank_BMCE})
        }
        else{
          const rib = jsonData?.[0]?.__EMPTY_6
          jsonData = jsonData
            .filter((e, key, a) => ![0, 1, a.length - 1, a.length - 2].includes(key) && e.__EMPTY_2 && e.__EMPTY_2.toLowerCase() !== "date")
            .map((e, i) => ({
              RELEVE_id: Number(i) + 1,
              RELEVE_excel_line: e.__rowNum__,
              RELEVE_date: e.__EMPTY_2 ? moment(e.__EMPTY_2, "DD/MM/YYYY") : null,
              RELEVE_libelle: e.__EMPTY_7 || "",
              RELEVE_valeur: e.__EMPTY_12 ? moment(e.__EMPTY_12, "DD/MM/YYYY") : null,
              RELEVE_debit: Math.abs(Number(e.__EMPTY_15 || 0)),
              RELEVE_credit: Number(e.__EMPTY_17 || 0),
            }))
          setData({lines: jsonData, rib, bankName: bank_AWB})
        }
      }
    }
    parseFile()
  }, [excelFiles])

  const virIsInRange = (date1, date2, days) => {
    if(!date1 || !date2)
      return false
    const d1: any = new Date(date1)
    const d2: any = new Date(date2)

    const diffDays = (d2 - d1) / (1000 * 60 * 60 * 24)
    return diffDays >= -1 && diffDays <= days
  }

  const rapprochementVir = (e, encaissements) => {
    const encF = encaissements.filter(t => t.MODE_REGL === constants.MODE_REGL_VIREMENT && Math.abs(Number(t.MONTANT || 0) - Number(e.RELEVE_amount || 0)) <= 1)
    let encFXdays = encF.filter(t => virIsInRange(t.DATE_PORTEFEUILLE, e.RELEVE_date, 4))
    console.log({encF, encFXdays})
    if(encFXdays.length === 0)
      encFXdays = encF.filter(t => virIsInRange(t.DATE_PORTEFEUILLE, e.RELEVE_date, 10))
    if(encFXdays.length === 0)
      encFXdays = encF
    if(encFXdays.length === 1)
      return {...e, ...encFXdays[0], encaissement: encFXdays[0]}
    else if(encFXdays.length > 1){
      let arrayToTake = encFXdays
      if(e.RELEVE_senderName){
        const senderName = e.RELEVE_senderName.toLowerCase()
        const encWithNameSimilarities = encFXdays.map(t => {
          if(!senderName || !t.TIRE_PAR)
            return t
          const senderNameWords = senderName.toLowerCase().split(" ").filter(e => e.length >= 3)
          const similarities = senderNameWords.filter(e => t.TIRE_PAR.toLowerCase().includes(e))
          return {...t, similarities}
        }).filter(e => e.similarities && e.similarities.length > 0).filter((e, _, a) => e.similarities.length === Math.max(...a.map(t => t.similarities.length)))
        if(encWithNameSimilarities.length === 1)
          return {...e, ...encWithNameSimilarities[0], encaissement: encWithNameSimilarities[0]}
        arrayToTake = encWithNameSimilarities.length > 0 ? encWithNameSimilarities : encFXdays
      }
      return {...e, encaissements: arrayToTake}
    }
    return e
  }

  const rapprochementVer = (e, encaissements) => {
    const encF = encaissements.filter(t => t.MODE_REGL === constants.MODE_REGL_VERSEMENT && Math.abs(Number(t.MONTANT || 0) - Number(e.RELEVE_amount || 0)) <= 1)
    let encFXdays = encF.filter(t => virIsInRange(t.DATE_PORTEFEUILLE, e.RELEVE_date, 4))
    if(encFXdays.length === 0)
      encFXdays = encF.filter(t => virIsInRange(t.DATE_PORTEFEUILLE, e.RELEVE_date, 10))
    if(encFXdays.length === 0)
      encFXdays = encF
    if(encFXdays.length === 1)
      return {...e, ...encFXdays[0], encaissement: encFXdays[0]}
    else if(encFXdays.length > 1){
      let arrayToTake = encFXdays
      if(e.RELEVE_senderName){
        const senderName = e.RELEVE_senderName.toLowerCase()
        const encWithNameSimilarities = encFXdays.map(t => {
          if(!senderName || !t.TIRE_PAR)
            return t
          const senderNameWords = senderName.toLowerCase().split(" ").filter(e => e.length >= 3)
          const similarities = senderNameWords.filter(e => t.TIRE_PAR.toLowerCase().includes(e))
          return {...t, similarities}
        }).filter(e => e.similarities && e.similarities.length > 0).filter((e, _, a) => e.similarities.length === Math.max(...a.map(t => t.similarities.length)))
        if(encWithNameSimilarities.length === 1)
          return {...e, ...encWithNameSimilarities[0], encaissement: encWithNameSimilarities[0]}
        arrayToTake = encWithNameSimilarities.length > 0 ? encWithNameSimilarities : encFXdays
      }
      return {...e, encaissements: arrayToTake}
    }
    return e
  }

  const rapprochement = (e, encaissements) => {
    const encF = encaissements.filter(t => t.MODE_REGL === constants.MODE_REGL_CHEQUE && Math.abs(Number(t.MONTANT || 0) - Number(e.RELEVE_amount || 0)) <= 1 && t.REF_REGLEMENT && t.REF_REGLEMENT.includes(Number(e.RELEVE_checkNumber || 0).toString()))
    if(encF.length === 1)
      return {...e, ...encF[0], encaissement: encF[0]}
    else if(encF.length > 1){
      const bank = (e.RELEVE_bank || "").toLowerCase()
      const encFBank = encF.filter(t => bank && t.bank && (t.bank.fullname?.toLocaleLowerCase() === bank || t.bank.name?.toLocaleLowerCase() === bank))
      if(encFBank.length === 1)
        return {...e, ...encFBank[0], encaissement: encFBank[0]}
      const arrayToTake = (encFBank.length > 0 ? encFBank : encF).filter(t => t.REF_REGLEMENT && t.REF_REGLEMENT.replace(/\D/g, '') === e.RELEVE_checkNumber)
      if(arrayToTake.length === 1)
        return {...e, ...arrayToTake[0], encaissement: arrayToTake[0]}
      return {...e, encaissements: arrayToTake}
    }
    return e
  }

  useEffect(() => {
    refreshResults()
  }, [data?.lines?.length, data?.bankName, encaissements.length])

  const refreshResults = () => {
    setVirements((data?.lines || []).map(e => {
      if(e.RELEVE_debit)
        return null
      if(!e.RELEVE_libelle?.toUpperCase().startsWith("VIR") && (data.bankName !== bank_BMCE || !e.RELEVE_libelle?.toUpperCase().startsWith("VRT")))
        return null
      if(e.RELEVE_libelle?.toUpperCase().startsWith("VIR SRBM") || e.RELEVE_libelle?.toUpperCase().startsWith("VRT_ORD") || e.RELEVE_libelle?.toUpperCase().startsWith("VRT_SRBM"))
        return null

      let senderName
      if(data.bankName === bank_AWB){
        const match = e.RELEVE_libelle?.match(/RECU DE\s+(.*)/i)

        senderName = match?.[1]?.trim().replace(/^(MLLE|MLE|MME|Mlle|Mme|ME|MR|Mr|M\.{0,2}|M\-|M )\s*/i, '')
          .replace(/[.\-\/\\_]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
      }
      else if(data.bankName === bank_BMCE){
        if(e.RELEVE_libelle?.toUpperCase().startsWith("VRT"))
          senderName = e.RELEVE_libelle?.substring(4).trim().replace(/^(MLLE|MLE|MME|Mlle|Mme|ME|MR|Mr|M\.{0,2}|M\-|M )\s*/i, '')
            .replace(/[.\-\/\\_]+/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
        else{
          const match = e.RELEVE_libelle?.match(/VIREMENT RECU DE:\s*([^,]+)/i)
          
          senderName = match?.[1]?.trim().replace(/\b(MLLE|MLE|MME|Mlle|Mme|ME|MR|Mr|M)\b/i, '')
            .replace(/[.\-\/\\_]+/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
        }
      }
      
      return {...e, RELEVE_senderName: senderName, RELEVE_amount: Number(e.RELEVE_credit || 0)}
    }).filter(Boolean).map(e => rapprochementVir(e, encaissements)))

    setVersements((data?.lines || []).map(e => {
      if(e.RELEVE_debit)
        return null
      if(!e.RELEVE_libelle?.toUpperCase().startsWith("VER"))
        return null
      let senderName

      if(data.bankName === bank_BMCE){
        const match = e.RELEVE_libelle?.match(/[\s\-]par\s+([A-Z\s]+?)(?=\s*[:\-]|$)/i)
        
        senderName = match?.[1]?.trim().replace(/\b(MLLE|MLE|MME|Mlle|Mme|ME|MR|Mr|M)\b/i, '')
          .replace(/[.\-\/\\_]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
      }
      
      return {...e, RELEVE_senderName: senderName, RELEVE_amount: Number(e.RELEVE_credit || 0)}
    }).filter(Boolean).map(e => rapprochementVer(e, encaissements)))

    setChecks((data?.lines || []).map(e => {
      if(e.RELEVE_debit)
        return
      if(!e.RELEVE_libelle?.toUpperCase().includes("CHEQUE"))
        return

      if(data.bankName === bank_AWB){
        const match = e.RELEVE_libelle?.match(/CHEQUE\s+(.+?)\s+N\s+(\d+)/)
        if(match){
          const RELEVE_bank = match[1]?.replace(/\./g, '')
          return {...e, RELEVE_bank: RELEVE_bank && RELEVE_bank.length <= 9 ? RELEVE_bank.replace(/\s+/g, '') : RELEVE_bank, RELEVE_checkNumber: match[2], RELEVE_amount: Number(e.RELEVE_credit || 0)}
        }
      }
      else if(data.bankName === bank_BMCE){
        const match = e.RELEVE_libelle?.match(/REFERENCE\s*:\s*(\d+)/)
        if(match)
          return {...e, RELEVE_checkNumber: match[1], RELEVE_amount: Number(e.RELEVE_credit || 0)}
      }
    }).filter(Boolean).map(e => rapprochement(e, encaissements)))
    
    setImpayes((data?.lines || []).map(e => {
      if(e.RELEVE_credit)
        return null
      if(data.bankName === bank_AWB){
        const match = e.RELEVE_libelle?.match(/CHEQUE (.+?) IMPAYE N[.\s](\d+)/i)
        if(match){
          const RELEVE_bank = match[1]?.replace(/\./g, '')
          return {...e, RELEVE_bank: RELEVE_bank && RELEVE_bank.length <= 9 ? RELEVE_bank.replace(/\s+/g, '') : RELEVE_bank, RELEVE_checkNumber: match[2], RELEVE_amount: Number(e.RELEVE_debit || 0)}
        }
      }
    }).filter(Boolean).map(e => rapprochement(e, encaissements)))
  }

  return <>
    <Container>
      <Row className="justify-content-between">
        <Col sm="12"><h2 className="title"><FontAwesomeIcon icon={faFileExcel} />&nbsp;&nbsp;Extraction du Relevé</h2></Col>
      </Row>
    </Container>
    <Container>
      <Row className="justify-content-around">
        <Col xs="12" sm="6">
          <FormGroup>
            <Label style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}><div>Relevé de compte</div>{loading ? <div style={{textAlign: "right", color: "red"}}><FontAwesomeIcon icon={faSpinner} className="spinner" />&nbsp;Chargement des données encaissements...</div> : <div style={{textAlign: "right"}}>{data?.rib ? `RIB: ${data.rib}` : ""}</div>}</Label>
            <section className="container">
              <div {...getRootProps({className: `dropzone${isDragActive ? " dropzoneHovered" : ""}`})}>
                <input {...getInputProps()} />
                {excelFiles?.length ? <aside className="thumbContainer">
                  <div className="thumbDelete" onClick={e => (e.stopPropagation(), setExcelFiles([]))} title="Supprimer le document"><FontAwesomeIcon icon={faTimes} style={{fontSize: "small"}} /></div>
                  <div className="thumb" style={{height: "50px"}} key={excelFiles[0].name}>
                    <div className="thumbInner">
                      <span className="thumbFileName"><FontAwesomeIcon icon={faFileExcel} style={{color: "green"}} />&nbsp;{excelFiles[0].name}</span>
                    </div>
                  </div>
                </aside> : <span style={{margin: "20px"}}><FontAwesomeIcon icon={faFileExcel} /> Choisir ou <FontAwesomeIcon icon={faHandRock} /> déposer le <span style={{fontWeight: 600}}>document</span> ici</span>}
              </div>
              
            </section>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
              <div style={{color: "darkgreen", fontSize: "x-small", cursor: "pointer"}} onClick={refreshData}><FontAwesomeIcon icon={faSyncAlt} />&nbsp;Actualiser les données de la base</div>
            </div>
          </FormGroup>
        </Col>
      </Row>
    </Container>

    <Container>
      <Nav tabs>
        {[
          {id: "RELEVE", label: "Relevé", icon: faFileExcel, count: data?.lines?.length || 0},
          {id: "VIREMENT", label: "Virements", icon: faExchangeAlt, isLoading: loading, count: virements.length},
          {id: "VERSEMENT", label: "Versements", icon: faMoneyBillWave, isLoading: loading, count: versements.length},
          {id: "CHECK", label: "Chèques", icon: faMoneyCheck, isLoading: loading, count: checks.length},
          {id: "IMPAYE", label: "Impayés", icon: faTimesCircle, isLoading: loading, count: impayes.length},
        ].map((e, key) => <NavItem key={key}>
          <NavLink
            className={`fullFlexCenter${activeTab === e.id ? " active" : ""}`}
            onClick={() => setActiveTab(e.id)} >
            <FontAwesomeIcon icon={e.icon} className="consultationTabIcons" />{e.label}{e.isLoading ? <FontAwesomeIcon icon={faSpinner} className="spinner" style={{marginLeft: "5px"}} /> : (e.count || e.count === 0 ? ` (${e.count})` : "")}
          </NavLink>
        </NavItem>)}
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId={"RELEVE"}>
          <Container>
            <TableContainer columns={columns} data={data?.lines || []} dataName="read_excel" enableCheckBox={false} showPagination={false} />
          </Container>
        </TabPane>
        <TabPane tabId={"VIREMENT"}>
          <RapprochementTable lines={virements.map(e => {
            return e.isDangerRow = !e.encaissement || e.preEncaisse === 1 || !e.STATUT || (constants.STATUT_ENC_PTF !== e.STATUT && constants.STATUT_ENC_EI !== e.STATUT), e
          })} setTableData={setVirements} selectedRows={selectedVirements} setSelectedRows={setSelectedVirements} clearFilters={clearFiltersVirements} setClearFilters={setClearFiltersVirements} loading={loading} selectTrigger={selectTriggerVirements} setSelectTrigger={setSelectTriggerVirements} isVirement />
          <RapprochementFooter encaissements={selectedVirements} refresh={refreshData} setClearFilters={setClearFiltersVirements} />
        </TabPane>
        <TabPane tabId={"VERSEMENT"}>
          <RapprochementTable lines={versements.map(e => {
            return e.isDangerRow = !e.encaissement || e.preEncaisse === 1 || !e.STATUT || (constants.STATUT_ENC_PTF !== e.STATUT && constants.STATUT_ENC_EI !== e.STATUT), e
          })} setTableData={setVersements} selectedRows={selectedVersements} setSelectedRows={setSelectedVersements} clearFilters={clearFiltersVersements} setClearFilters={setClearFiltersVersements} loading={loading} selectTrigger={selectTriggerVersements} setSelectTrigger={setSelectTriggerVersements} isVersement />
          <RapprochementFooter encaissements={selectedVersements} refresh={refreshData} setClearFilters={setClearFiltersVersements} />
        </TabPane>
        <TabPane tabId={"CHECK"}>
          <RapprochementTable lines={checks.map(e => {
            return e.isDangerRow = !e.encaissement || e.preEncaisse === 1 || !e.STATUT || constants.STATUT_ENC_EI !== e.STATUT, e
          })} setTableData={setChecks} selectedRows={selectedChecks} setSelectedRows={setSelectedChecks} clearFilters={clearFiltersChecks} setClearFilters={setClearFiltersChecks} loading={loading} selectTrigger={selectTriggerChecks} setSelectTrigger={setSelectTriggerChecks} isCheque />
          <RapprochementFooter encaissements={selectedChecks} refresh={refreshData} setClearFilters={setClearFiltersChecks} />
        </TabPane>
        <TabPane tabId={"IMPAYE"}>
          <RapprochementTable lines={impayes.map(e => {
            return e.isDangerRow = !e.encaissement || e.preImpaye === 1 || !e.STATUT || constants.STATUT_ENC_EI !== e.STATUT, e
          })} setTableData={setImpayes} selectedRows={selectedImpayes} setSelectedRows={setSelectedImpayes} clearFilters={clearFiltersImpayes} setClearFilters={setClearFiltersImpayes} loading={loading} selectTrigger={selectTriggerImpayes} setSelectTrigger={setSelectTriggerImpayes} isImpaye />
          <RapprochementFooter encaissements={selectedImpayes} refresh={refreshData} setClearFilters={setClearFiltersImpayes} isImpaye />
        </TabPane>
      </TabContent>
    </Container>
    <EncaissementScanModal modal={modal} setModal={setModal} modalEncaissement={modalEncaissement} setModalEncaissement={setModalEncaissement} />
  </>
}

const mapStateToProps = (state: IRapprochementEncReduxProps) => ({
  encaissement: state.encaissement,
  auth: state.auth
});

export default connect(mapStateToProps, { getEncaissementsExcel, clearEncaissements })(RapprochementEncContainer);